import { httpRequest } from "src/services/httpRequest";

/**
 * Checks if all UCC forms for an application are completed
 * @param applicationId The application ID to check
 * @returns Object containing status information and pending forms if any
 */
export const checkUCCFormStatus = async (applicationId: string) => {
    try {
      const statusResponse = await httpRequest(
        'GET',
        `/construction/${applicationId}/check_ucc_form_status`
      );
  
      // Default response
      const result = {
        success: false,
        allFormsCompleted: false,
        pendingForms: [],
        error: null
      };
  
      if (statusResponse?.status === 'success') {
        // Case 1: No forms shared or all forms found are completed
        if (
          statusResponse.message === 'No UCC forms found' ||
          (Array.isArray(statusResponse.data) && statusResponse.data.length === 0)
        ) {
          return {
            ...result,
            success: true,
            allFormsCompleted: true
          };
        }
        
        // Case 2: We have form data, check for pending forms
        const formData = statusResponse.data;
        const pendingFormDetails = [];
        let hasPendingForms = false;
  
        // Check each form type for pending forms
        Object.keys(formData).forEach((formType) => {
          if (formData[formType] && formData[formType].length > 0) {
            const currentForm = formData[formType][0];
            if (currentForm.Pending && currentForm.Pending > 0) {
              hasPendingForms = true;
              pendingFormDetails.push({
                formType: formType,
                pendingCount: currentForm.Pending,
                items: currentForm.Items.filter((item) => !item.IsFilled)
              });
            }
          }
        });
  
        return {
          ...result,
          success: true,
          allFormsCompleted: !hasPendingForms,
          pendingForms: pendingFormDetails
        };
      } else {
        // Error in API response
        return {
          ...result,
          error: 'Failed to verify form status. Please try again.'
        };
      }
    } catch (error) {
      console.error('Error checking UCC form status:', error);
      return {
        success: false,
        allFormsCompleted: false,
        pendingForms: [],
        error: 'Failed to verify form status. Please try again.'
      };
    }
  };